module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA7.557aebce.jpg";